import { initialRaceResultState, IRaceResultState } from '../state/raceresult.state';
import { RaceResultActions, ERaceResultActions } from '../actions/raceresult.actions';


export const receResultReducers = (
    state = initialRaceResultState,
    action: RaceResultActions
): IRaceResultState => {
    switch (action.type) {
        case ERaceResultActions.GetRaceResultSuccess: {
            return {
                ...state,
                raceResult: action.payload
            };
        }

        default:
            return state;
    }
};
